module.exports = new __parcel__URL__("full_screen.abbdff50.png").toString();